"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var scale = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var batteryId = _utils.screeners.ALLIANZ_PROGRESS;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  options: scale
};
var progressQuestions = [// STRESS - 5 questions
{
  prompt: "How would you rate the Allianz Care Mental Wellbeing program overall?",
  extraText: "",
  type: "slider",
  options: scale,
  key: "npsUprise",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "ALLIANZ_PROGRESS"
}, {
  prompt: "How would you rate your experience with your coach?",
  extraText: "",
  type: "slider",
  options: scale,
  key: "npsCoach",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "ALLIANZ_PROGRESS"
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  extraText: "",
  meta: {
    answerLabel: "My feedback is..",
    summaryTitle: "Your action for Other was…",
    placeholder: ""
  },
  type: "textarea",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "ALLIANZ_PROGRESS"
}];
var questions = (0, _utils.wrapBattery)(progressQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  return {
    PROGRESS_1: answers === null || answers === void 0 ? void 0 : answers[0],
    PROGRESS_2: answers === null || answers === void 0 ? void 0 : answers[1],
    PROGRESS_3: answers === null || answers === void 0 ? void 0 : answers[2]
  };
}